import { useNavigate } from 'react-router-dom';
import { Button, C, Card, ErrorNote, Muted, SectionTitle, Title } from '../ui';
import { CommerceItem, Stat } from '../components';
import { useCommerces } from '../useCommerces';
import { useDesktop } from '../../utils/hooks/useDesktop';

const Dashboard = () => {
  const navigate = useNavigate();
  const isDesktop = useDesktop();
  const { commerces, loading, error } = useCommerces();
  const drafts = commerces.filter((c) => c.estado === 'draft');
  const claimed = commerces.filter((c) => c.estado === 'reclamado');
  const recent = commerces.slice(0, 5);

  return (
    <>
      {/* Header: en móvil el título arriba y el CTA full-width debajo; en desktop en línea. */}
      <div
        style={{
          display: 'flex',
          flexDirection: isDesktop ? 'row' : 'column',
          justifyContent: 'space-between',
          alignItems: isDesktop ? 'center' : 'stretch',
          gap: isDesktop ? 12 : 14,
          marginBottom: 18,
        }}
      >
        <Title>Resumen</Title>
        <Button fullWidth={!isDesktop} onClick={() => navigate('/partner/comercios/nuevo')}>
          Nuevo comercio
        </Button>
      </div>

      {/* Stats: grid que apila a 1 columna en móvil y pasa a 3 en tablet/desktop sin overflow. */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: 12,
          marginBottom: 16,
        }}
      >
        <Stat label="Comercios totales" value={commerces.length} />
        <Stat label="Por activar" value={drafts.length} tone={C.secondary} />
        <Stat label="Activados" value={claimed.length} tone={C.success} />
      </div>

      <Card>
        <div
          style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}
        >
          <SectionTitle>Comercios recientes</SectionTitle>
          <Button variant="ghost" size="sm" onClick={() => navigate('/partner/comercios')}>
            Ver todos
          </Button>
        </div>
        {loading && <Muted>Cargando...</Muted>}
        {error && <ErrorNote>{error}</ErrorNote>}
        {!loading && !error && commerces.length === 0 && (
          <div style={{ textAlign: 'center', padding: '28px 12px' }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: C.primary }}>Aún no hay comercios</div>
            <Muted style={{ marginTop: 6 }}>Registra el primero para empezar a activarlos.</Muted>
            <div style={{ marginTop: 16, display: 'inline-flex' }}>
              <Button onClick={() => navigate('/partner/comercios/nuevo')}>Crear comercio</Button>
            </div>
          </div>
        )}
        {recent.map((c) => (
          <CommerceItem key={c.id_suscripcion} c={c} />
        ))}
      </Card>
    </>
  );
};

export default Dashboard;
